exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".featuresMenu{display:flex;justify-conten:space-between;flex-wrap:wrap}.featuresMenu__list{width:100%;margin:0 0 10px;padding:5px;box-sizing:border-box}.featuresMenu__color{width:10px;height:10px;display:inline-block;margin:0 5px 0 0}@media only screen and (min-width:480px){.featuresMenu__wrapper{width:450px}.featuresMenu__list{width:50%}}@media only screen and (min-width:768px){.featuresMenu__wrapper{width:100%;left:0}.featuresMenu__list{width:33.33333%}}@media only screen and (min-width:992px){.featuresMenu__list{width:25%}}@media only screen and (min-width:1200px){.featuresMenu__list{width:20%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ddeab78","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mainMenuFeatures.vue
// module id = 193
// module chunks = 0